export default __webpack_public_path__ + "static/media/25.2c639e49.jpeg";